module.exports = __webpack_public_path__ + "img/PaymentHistory.8d493936.svg";